/**
 * Initializes Swiper for product-media-slider.liquid: one swiper for the main
 * viewer (.swiper-main) and one for the thumbnail strip (.thumbnail-swiper),
 * linked via Swiper's built-in Thumbs module so clicking a thumbnail slides
 * the main viewer and the corresponding thumbnail highlights automatically.
 *
 * The zoom/lightbox modal (product-modal.js) and hover zoom (magnify.js)
 * aren't touched here: they operate on the modal-opener/data-media-id markup
 * rendered by 'product-thumbnail', which this snippet still renders as-is.
 *
 * Swiper has built-in RTL support (it reads the page/container's `dir`
 * automatically), so no extra direction handling is needed here.
 */
if (typeof Swiper !== 'undefined') {
  document.querySelectorAll('.swiper-main').forEach((viewerEl) => {
    if (viewerEl.swiper) return;

    const rootEl = viewerEl.parentElement;
    const thumbsEl = rootEl.querySelector('.thumbnail-swiper');
    const shouldSyncToVariant = rootEl.dataset.updateMediaOnVariantChange !== 'false';

    const findActiveIndex = (wrapperEl) => {
      if (!wrapperEl) return 0;
      const slides = Array.from(wrapperEl.children);
      const index = slides.findIndex((slide) => slide.dataset.active === 'true');
      return index > -1 ? index : 0;
    };

    const viewerWrapperEl = viewerEl.querySelector('.swiper-wrapper');
    const initialSlide = findActiveIndex(viewerWrapperEl);

    let thumbsSwiper = null;

if (thumbsEl && !thumbsEl.swiper) {
  const thumbWrapperEl = thumbsEl.parentElement;

  thumbsSwiper = new Swiper(thumbsEl, {
    slidesPerView: 3,
    spaceBetween: 15,
    watchOverflow: true,
    initialSlide,
    preventClicks: false,
    preventClicksPropagation: false,

    navigation: {
      prevEl: thumbWrapperEl.querySelector('.slider-button--prev'),
      nextEl: thumbWrapperEl.querySelector('.slider-button--next'),
    },

    breakpoints: {
      990: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    },
  });
}

    const viewerSwiper = new Swiper(viewerEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      initialSlide,
      preventClicks: false,
      preventClicksPropagation: false,
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
    });

    if (shouldSyncToVariant && typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data.sectionId !== rootEl.dataset.sectionId) return;
        const variantFeaturedMediaId = event.data.variant?.featured_media?.id;
        if (!variantFeaturedMediaId) return;

        const targetMediaId = `${rootEl.dataset.sectionId}-${variantFeaturedMediaId}`;
        const slides = Array.from(viewerWrapperEl.children);
        const index = slides.findIndex((slide) => slide.dataset.mediaId === targetMediaId);
        if (index > -1) viewerSwiper.slideTo(index);
      });
    }
  });
}
